import React from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Box,
  Menu, MenuItem, Tooltip, Avatar, Chip, Stack, Divider
} from '@mui/material';
import {
  Logout as LogoutIcon,
  Business as OrgIcon,
  Layers as WorkspaceIcon,
  NotificationsNone as NotificationIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import { auth } from '../../firebase/config';
import { signOut } from 'firebase/auth';

const Header: React.FC = () => {
  const { user } = useAuth();
  const { organizationId, workspaceId } = useTenant();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


  const handleMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);

  };

  const handleLogout = () => signOut(auth);

  return (
    <AppBar position="fixed" elevation={0} sx={{
      zIndex: (theme) => theme.zIndex.drawer + 1,
      bgcolor: 'background.paper',
      borderBottom: '1px solid',
      borderColor: 'divider'
    }}>
      <Toolbar>
        <Typography variant="h6" noWrap sx={{
          flexGrow: 1,
          fontWeight: 900,
          letterSpacing: '-0.5px',
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <Box sx={{ width: 32, height: 32, bgcolor: 'primary.main', borderRadius: 1.5 }} />
          SPARK CRM
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          {/* Workspace Switcher */}
          <Chip
            icon={<WorkspaceIcon fontSize="small" />}
            label={workspaceId || 'Select Workspace'}
            variant="outlined"
            sx={{
              borderRadius: 1,
              fontWeight: 'bold',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' }
            }}
          />
          {/* Org Info (Read-only for now) */}
          <Tooltip title="Organization">
            <Chip
              icon={<OrgIcon fontSize="small" />}
              label={organizationId || 'None'}
              color="primary"
              sx={{ borderRadius: 1, fontWeight: 'bold' }}
            />
          </Tooltip>

          <IconButton color="inherit" size="small">
            <SearchIcon />
          </IconButton>

          <IconButton color="inherit" size="small">
            <NotificationIcon />
          </IconButton>

          <Tooltip title="Profile">
            <IconButton onClick={handleMenu} sx={{ p: 0.5 }}>
              <Avatar
                sx={{ width: 32, height: 32, fontSize: '14px', bgcolor: 'secondary.main' }}
              >
                {user?.email?.charAt(0).toUpperCase() || 'U'}
              </Avatar>
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography variant="subtitle2">{user?.email}</Typography>
              <Typography variant="caption" color="textSecondary">Active Session</Typography>
            </Box>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <LogoutIcon fontSize="small" sx={{ mr: 1.5 }} />
              Sign Out
            </MenuItem>
          </Menu>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
